import {Component, OnInit} from '@angular/core';
import {RestService} from '../../shared/service/rest.service';

import {AuthService} from 'src/shared/service/auth.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {AbstractDataProvider} from '../AbstractDataProvider';
import {Subject} from 'rxjs';
import {DynamicModalService} from '../ui-components/dynamic-modals/dynamic-modal.service';
import {JqueryDialogService} from '../ui-components/jquery-dialog/jquery-dialog.service';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {finalize} from 'rxjs/operators';
import {getErrorMessageText} from '../helper';

export const EmailRegex = new RegExp('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$');


enum Status {
  'NotFound' = 'NotFound',
  'MultipleFound' = 'MultipleFound',
  'DupMailFound' = 'DupMailFound',
  'LinkAccounts' = 'LinkAccounts',
  'HasAccess' = 'HasAccess',
  'GiveAccess' = 'GiveAccess',
  'NotAllowed' = 'NotAllowed',
  'CanNotBeAdded' = 'CanNotBeAdded',
}

interface OtherLoginEmailValidationResult {
  Success: boolean;
  Result: Status;
  Message: string;
  FoundRecordType: string;
  FoundRecordNum: number;
  FoundEmail: string;
  FoundName: string;
  FoundAddrLine1: string;
  FoundAddrLine2: string;
  FoundAddrLine3: string;
}

enum Step {
  EmailValidation = 'EmailValidation',
  CanNotBeAdded = 'CanNotBeAdded',
  DupMailFound = 'DupMailFound',
  HasAccess = 'HasAccess',
  GiveAccess = 'GiveAccess',
  LinkAccounts = 'LinkAccounts',
  NotFound = 'NotFound',
}

@Component({
  selector: 'app-add-new-login-modal',
  templateUrl: './add-new-login-modal.component.html',
  styleUrls: ['./add-new-login-modal.component.scss']
})
export class AddNewLoginModalComponent implements OnInit {
  possibleSteps = Step;
  currentStep = Step.EmailValidation;
  errorMessageText = '';
  display = false;
  alertMessage: string;
  accountInfo: OtherLoginEmailValidationResult;
  public subjectOnClose: Subject<any>;
  form: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.pattern(EmailRegex)]),
  });

  newAccountForm: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl({value: '', disabled: true}, [Validators.required, Validators.pattern(EmailRegex)]),

    name: new UntypedFormControl('', [Validators.required]),
    line1: new UntypedFormControl(''),
    line2: new UntypedFormControl(''),
    line3: new UntypedFormControl(''),
    city: new UntypedFormControl(''),
    state: new UntypedFormControl(''),
    zip: new UntypedFormControl(''),
    phone: new UntypedFormControl(''),
  });

  constructor(
    public rest: RestService,
    public authService: AuthService,
    private dynamicModalService: DynamicModalService,
    private ngxService: NgxUiLoaderService,
    private jqueryDialogService: JqueryDialogService,
    private abstractDataProvider: AbstractDataProvider) {
  }

  ngOnInit() {

    this.newAccountForm.get('line1').valueChanges.subscribe((val) => {
      const controls = ['city', 'zip', 'state'];
      if (val) {
        controls.forEach(c => {
          this.newAccountForm.get(c).setValidators([Validators.required]);
          this.newAccountForm.get(c).updateValueAndValidity();
        });
      } else {
        controls.forEach(c => {
          this.newAccountForm.get(c).setValidators([]);
          this.newAccountForm.get(c).updateValueAndValidity();

        });
      }
    });
  }

  onClosePopup() {
    this.display = false;
  }

  private linkAccount(dto): void {
    this.ngxService.start();
    this.abstractDataProvider.postData(
      dto, 'api/Accounts/AddOtherLoginAccount').pipe(
      finalize(() => this.ngxService.stop())
    ).subscribe((data: any) => {
      this.close(true);
    }, error => {
      this.display = true;
      this.alertMessage = getErrorMessageText(error);
    });
  }

  saveAccount(): void {
    if (this.newAccountForm.invalid) {
      this.newAccountForm.updateValueAndValidity();
      this.newAccountForm.markAllAsTouched();
      return;
    }

    // TODO: fix this code
    // if (this.ngxService.getLoaders().master.foreground.default) {
    //   return;
    // }

    const dto = {
      WpUserNum: parseInt(this.authService.currentUserProfileEntity.WpUserNum, 10),
      EmailAddress: this.newAccountForm.get('email').value,
      Name: this.newAccountForm.get('name').value,
      AddrLine1: this.newAccountForm.get('line1').value,
      AddrLine2: this.newAccountForm.get('line2').value,
      AddrLine3: this.newAccountForm.get('line3').value,
      City: this.newAccountForm.get('city').value,
      State: this.newAccountForm.get('state').value,
      ZipCode: this.newAccountForm.get('zip').value,
      Phone: this.newAccountForm.get('phone').value,
    };
    this.linkAccount(dto);
  }

  getAccountType(type: string): string {
    if (type === 'I') {
      return 'Investor';
    } else if (type === 'R') {
      return 'Rep';
    } else {
      return type;
    }
  }

  link(): void {

    // TODO: fix this code
    // if (this.ngxService.getLoaders().master.foreground.default) {
    //   return;
    // }
    this.ngxService.start();
    const dto = {
      WpUserNum: parseInt(this.authService.currentUserProfileEntity.WpUserNum, 10),
      EmailAddress: this.accountInfo.FoundEmail,
      Name: this.accountInfo.FoundName,
      AddrLine1: this.accountInfo.FoundAddrLine1,
      AddrLine2: this.accountInfo.FoundAddrLine2,
      AddrLine3: this.accountInfo.FoundAddrLine3,
    };
    this.linkAccount(dto);
  }

  validate(): void {
    if (this.form.invalid) {
      this.form.updateValueAndValidity();
      this.form.markAllAsTouched();
      return;
    }
    // TODO: fix this code
    // if (this.ngxService.getLoaders().master.foreground.default) {
    //   return;
    // }

    this.accountInfo = null;
    this.errorMessageText = '';

    this.ngxService.start();
    const email = this.form.get('email').value;
    this.abstractDataProvider.postData(
      {
        EmailAddress: email,
        WpUserNum: parseInt(this.authService.currentUserProfileEntity.WpUserNum, 10),
      }, 'api/Accounts/CheckOtherLoginEmail').pipe(
      finalize(() => this.ngxService.stop())
    ).subscribe((data: { Data: OtherLoginEmailValidationResult }) => {
      if (data.Data.Result === Status.CanNotBeAdded
        || data.Data.Result === Status.NotAllowed
        || data.Data.Result === Status.MultipleFound) {
        this.errorMessageText = data.Data.Message;
        this.currentStep = Step.CanNotBeAdded;
        return;
      }
      if (data.Data.Result === Status.HasAccess) {
        this.currentStep = Step.HasAccess;
        this.errorMessageText = data.Data.Message;
        this.accountInfo = data.Data;
        return;
      }
      if (data.Data.Result === Status.GiveAccess) {
        this.currentStep = Step.GiveAccess;
        this.errorMessageText = data.Data.Message;
        this.accountInfo = data.Data;
        return;
      }
      if (data.Data.Result === Status.DupMailFound) {
        this.currentStep = Step.DupMailFound;
        this.errorMessageText = data.Data.Message;
        this.accountInfo = data.Data;
        return;
      }
      if (data.Data.Result === Status.LinkAccounts) {
        this.currentStep = Step.LinkAccounts;
        this.accountInfo = data.Data;
        return;
      }
      if (data.Data.Result === Status.NotFound) {
        this.newAccountForm.get('email').setValue(this.form.get('email').value);
        this.currentStep = Step.NotFound;
        return;
      }
    }, error => {
      this.display = true;
      this.alertMessage = getErrorMessageText(error);
    });
  }

  submit(): void {
  }

  cancel() {
    this.close(false);
  }

  close(result: any = null) {
    if (this.subjectOnClose && this.subjectOnClose.observers.length > 0) {
      this.subjectOnClose.next(result);
    }
    this.dynamicModalService.subject.next(null);
  }
}
